import { render } from "./ImageLoader.vue?vue&type=template&id=0a17b5cc&scoped=true"
import script from "./ImageLoader.vue?vue&type=script&lang=js"
export * from "./ImageLoader.vue?vue&type=script&lang=js"

import "./ImageLoader.vue?vue&type=style&index=0&id=0a17b5cc&scoped=true&lang=css"

import exportComponent from "/var/www/sites/avaliacao/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a17b5cc"],['__file',"ImageLoader.vue"]])

export default __exports__